<template>
  <div>
    <b-row>
      <b-button variant="primary" class="mb-2 mr-3 ml-auto" @click="stopAlimtalk" >사용중지</b-button>
    </b-row>
    <b-table-simple
      class="table b-table text-center"
      responsive
      show-empty>
      <b-thead class="thead-light">
        <b-tr>
          <b-th >매장명</b-th>
          <b-th >매장운영</b-th>
          <b-th >알림톡</b-th>
          <b-th ><b-form-checkbox v-model="allCheck" :unchecked-value="false"  /></b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="(item,idx) in storeListData" v-bind:key="idx">
          <b-td>{{ item.storeName }}</b-td>
          <b-td>
            <button v-if="item.enable == true" type="button" class="btn btn-xs mb-1 btn-success default" style="border-radius: 4px">활성화</button>
            <button v-if="item.enable == false" type="button" class="btn btn-xs mb-1 btn-secondary custom-secondary-button default" style="border-radius: 4px; ">비활성화</button>
          </b-td>
          <b-td>
            <b-button v-if="!item.alimtalk.status || item.alimtalk.status=='UnUse'" variant="primary" class="btn" @click="regAlimtalk(item.storeCode,item.alimtalk)">등록 신청</b-button>
            <span v-if="item.alimtalk.status == 'RegisterRequested' " class="font-weight-bold text-danger" style="margin-right: 2px">검수중</span>
            <span v-if="item.alimtalk.status=='Use' ">{{ item.alimtalk.kakaoName }}</span>
          </b-td>
          <b-td>
            <b-form-checkbox v-if="storeOptionData[idx].useYN ==true" :checked="true" :unchecked-value="false" v-model="storeOptionData[idx].status" :id="`${'storeSelectList'[idx]}`" name="storeSelectList" />
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>


import {mapGetters} from "vuex";
import api from "@/constants/api";

export default {
  data() {
    return{
      allCheck:false,
      storeListData : [],
      storeSelectList: [],
      storeOptionData:[],
      infoData:{},
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'siteName','info'])
  },
  mounted() {
    console.log(this.siteName)
    this.getInfo();
    this.getList();
  },
  watch: {
    allCheck(chk) {
      if(chk == true){
        this.storeOptionData.forEach(item=>{
          if(item.useYN == true){
            item.status=true
          }

        })
      }else if(chk == false){
        this.storeOptionData.forEach(item=>{
          if(item.useYN == true){
            item.status=false
          }
        })
      }
    },
  },
  methods:{
    getInfo(){
      //siteInfoData
      let reqURL = ''
      reqURL = api.changeAPI(this.siteName, api.basicURL + api.siteSet.siteInfoData)
      this.$http.get(reqURL,  {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if (res.data.code === "OK") {
          this.infoData = res.data.data

        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })
    },
    getList(){
      this.storeOptionData = []
      let reqURL = ''
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.alimtalkMng.getBrandStoreList)
      // const params =
      //   {"site_name": this.siteName}
      this.$http.get(reqURL,  {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if (res.data.code === "OK") {
          this.storeListData = res.data.data
          this.storeListData.forEach((item,idx)=>{
            if((item.alimtalk.status=='Use') && item.enable == true){
              this.storeOptionData.push({storeCode:item.storeCode , status: false, useYN: true})
            }else{
              this.storeOptionData.push({storeCode:item.storeCode , status: false, useYN: false})
            }

          })

          console.log(this.storeListData)
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })
    },
    stopAlimtalk() {
      this.storeSelectList=[]
      this.storeOptionData.forEach(item=>{
        if (item.useYN==true && item.status==true){
          this.storeSelectList.push(item.storeCode)
        }
      })

      if(this.storeSelectList.length==0){
        alert("매장을 선택해 주세요.")
        return false;
      }else{
        let chkVal = confirm("알림톡 사용을 중지하시겠습니까?\n재사용을 원하시는 경우 등록 신청을 다시 진행해 주셔야 합니다.");
        if(chkVal){

          // this.storeSelectList.forEach(item=>{
          //   storeList.push(item.storeCode)
          // })


          let reqURL = ''
          reqURL = api.changeAPI(this.siteName, api.basicURL + api.alimtalkMng.brandStoresAlimtalkStop)
          const params = {
            storeCodes : this.storeSelectList
          }
          console.log(this.storeSelectList)
          if(this.storeSelectList.length!=0){
            this.$http.post(reqURL,params,  {
              headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
            }).then(res => {

              if (res.data.code === "OK") {
                this.tmpData = res.data.data

              } else {
                throw 400
              }
              this.getList();
            }).catch(err => {
              alert(err.response.data.message);
            })
            this.getList();
          }else {
            alert("매장을 선택해 주세요");
            return
          }
        }
      }
    },
    regAlimtalk(storeCode,item){
      let storeData = item
      console.log(item)
      if(storeData.kakaoId != null && storeData.kakaoId != undefined && storeData.kakaoId != ""){
        let chkVal = confirm(`이전에 사용한 카카오톡 채널이 있습니다. (${storeData.kakaoName}) \n동일한 카카오톡 채널로 이용 하시겠습니까? (확인) \n신규 카카오톡 채널로 등록 신청 하시겠습니까? (취소)` );
        if(chkVal){
         let reqURL = api.changeAPI(this.siteName, api.basicURL + api.alimtalkMng.regBrandStoreAlimtalk)
          let params = {
            type : "STORE",
            kakaoId : storeData.kakaoId,
            phoneNumber: storeData.adminNumber,
            smsRegister : storeData.smsRegister,
            smsSendNumber : storeData.smsSendNumber,
            smsRegisterDocumentUrl : storeData.smsRegisterDocumentUrl,
            smsCertificateDocumentUrl : storeData.smsCertificateDocumentUrl,
            categoryCode : storeData.categoryData.categoryCode,
            storeCode : storeCode,
            registerType: "EXISTREAPPLY"
          }
          this.$http.post(reqURL,params,  {
            headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
          }).then(res => {
            if (res.data.code === "OK") {
              this.tmpData = res.data.data
            } else {
              throw 400
            }
            this.getList();
          }).catch(err => {
            alert(err.response.data.message);
          })
        }else{
          this.$router.push(`${'/'+this.siteName+'/siteSet/AlimtalkReg?reg=REAPPLY&storeCode='+storeCode}`)
        }
      }else{
        this.$router.push(`${'/'+this.siteName+'/siteSet/AlimtalkReg?reg=NEW&storeCode='+storeCode}`)
      }
    }
  }
}
</script>



<style scoped>

.custom-secondary-button {
  background: #6f6f6f;
  border: #6f6f6f;
}

</style>
